<!-- spinner -->
@if (showLoader) {
  <div>
    <h4 class="order-summary-title">{{ 'orderCost.orderSummary' | cxTranslate }}</h4>
    <div class="cx-spinner">
      <cx-spinner></cx-spinner>
    </div>
  </div>
} @else {
  @if (cart$ | async; as cart) {
    @if (entries$ | async; as entries) {
      <app-custom-order-summary [cart]="cart"></app-custom-order-summary>
      @if (entries.length && !saveCart) {
        @if (sharedService.getUser() | async) {
          @if (sharedService.isUserCreditHold) {
            <app-credit-hold-message> </app-credit-hold-message>
          }
        }
        <button
          [disabled]="disableCheckout(cart)"
          class="btn btn-primary btn-block"
          (click)="onCheckout()"
          type="button"
          >
          {{ 'cartDetails.proceedToCheckout' | cxTranslate }}
        </button>
        <button
          [disabled]="sharedService.disableSimulate"
          class="btn btn-block btn-action"
          (click)="onSimulateCart()"
          type="button"
          >
          {{ 'cart.recalculate' | cxTranslate }}
        </button>
        <button class="btn btn-action btn-block" (click)="onSaveCart(cart.code)" type="button">
          {{ 'cart.saveCart' | cxTranslate }}
        </button>
      }
    }
  }
}
@if (saveCart) {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}

